import React, { Component } from "react";
import axios from "axios";

import TeamItem from "./TeamItem";

export class TeamBanners extends Component {
    state = {
        teams: [],
        isLoaded: false,
    };
    
    componentDidMount() {
        axios
        .get("https://obrien365.com/ob-wp/wp-json/wp/v2/teams/")
        .then((res) =>
        this.setState({
            teams: res.data,
            isLoaded: true,
        })
        )
        .catch((err) => console.log(err));
    }

    
    
    render() {
    const { teams, isLoaded } = this.state;
    if (isLoaded) {
        return (
        <div className="App home-team">
            
            {teams.map(team => (
                //@ts-ignore
                <TeamItem key={team.id} team={team} />
            ))}
            
        </div>
        );
    }
    return <div className="loading"><h3>Loading...</h3></div>;
    }
}
export default TeamBanners;